import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { scan } from "react-scan";
import "@/config/i18n.config";
import "./style.css";
import App from "./App.tsx";
import { initLogger } from "./config/logger.config.ts";
import { enableMocking } from "./mocks/enableMocking.ts";

if (typeof window !== "undefined" && import.meta.env.VITE_DEBUG === "true") {
  console.info("🔍: Perfmormance monitoring enabled");
  scan({
    enabled: true,
  });
}

initLogger();

// Optionally boot the MSW mock layer before rendering so the first queries are
// already intercepted. This is a no-op unless VITE_ENABLE_MSW=true (dev:mock).
// A failure to start the mock worker must never block the app from rendering,
// so we catch it and render regardless.
async function bootstrap() {
  try {
    await enableMocking();
  } catch (error) {
    console.error(
      "MSW mock worker failed to start; continuing without it.",
      error
    );
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

bootstrap();
